import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    firstName: "",
    lastName: "",
    user_type: '',
    email: "",
    stack: "",
    category: "",
    difficulty: "",
    userAnswers: [],
    grade: "",
    designchoice: "",
    theoryQuestions: '',
    found: 0
  },
  mutations: {
    //
  },

  // plugins: [
  //   createPersistedState({
  //     getState: key => Cookies.getJSON(key),
  //     setState: (key, state) =>
  //       Cookies.set(key, state, { expires: 3, secure: true })
  //   })
  // ],
  actions: {},
  getters: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js